import React from "react";

export function ConfirmDialog({showConfirmDialog, setShowConfirmDialog, confirmMessage, onConfirm}) {
     
    if(!showConfirmDialog){
        return "";
    }
    
    function cancel(){
        setShowConfirmDialog(false);         
    }

    function confirm(){
      console.log("!!!Inside confirm!!!");
        onConfirm();
        // setAgentsChangedTrigger(true);
        setShowConfirmDialog(false);   

    }

  return (
    <div className="modal">
      <div class="modal-content">
        <div>
          <p>{confirmMessage}</p>
        </div>
        <div className="clearfix">
          <div className="row">
            <div className="col">
              <button className="ips ipc" onClick={cancel}>
                Cancel
              </button>
            </div>
            <div className="col">
              <button className="ips ipc" onClick={confirm}>
                Confirm
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
